<script>
import store from '@state/store'
import con from '@services/connection'
import { GlobalBus } from '@services/bus'
import { resetAllModules } from '@utils/reset-store'
import LeftBar from '@components/left-bar-actions.vue'

import {
  MODAL,
  RELOAD,
  RUNNING,
  STOP,
  ACTION,
  FEATURES,
  CANT_ACCESS_FUNCTION,
} from '@constants/Text'
import {
  toTitleCase,
  possivelJSON,
  getInitials,
  removeAccents,
} from '@utils/Format'
import { user, pdf, atualizar, adicionarTransacao } from '@constants/URL'
import { funcaoIndisponivel } from '@utils/Whitelabel'
import P from '@services/parameters'
import LineProcess from '@components/resumo/line-process'
import moment from 'moment'
import ProfessionalAvatar from '@modules/partnership/components/professional-avatar.vue'
import ButtonNavbar from '@modules/global/components/button-navbar/button-navbar.vue'
import { apiNotifications } from '@modules/notifications/api/apiNotifications'
import { mapGetters } from 'vuex'
import { textOnColor } from '@modules/global/utils/Color'
import { emailDoCliente } from '@utils/clienteEmail'

import { additionalPermissions } from '@utils/AdditionalPermissions'
import { apiConsolidatorCotizacao } from '@modules/consolidator/api/apiConsolidatorCotizacao'
import { apiPowerBIDashboard } from '@modules/power-bi/api/apiPower-biDashboard'

import {
  buildRoutes,
  buildAnaliseRoutes,
  buildOperationalRoutes,
  buildManagerOfficeRoutes,
  buildManagerPortfolioRoutes,
  buildManagerPeopleRoutes,
  buildManagerToolsRoutes,
  buildManagerOutersRoutes,
  buildSettingsRoutes,
  buildClienteRoutes,
  buildProfissionalRoutes,
  financeSettingsRouteName,
} from '@constants/navigation-routes'
import { formatBrokerCode } from '@utils/cliente-codigo/cliente-codigo'

export default {
  components: {
    LineProcess,
    ProfessionalAvatar,
    LeftBar,
    ButtonNavbar,
  },
  data() {
    return {
      moment,
      GlobalBus: GlobalBus,
      runningCotizacao: false,
      pollingCancelled: false,
      pollingTimerAccounts: null,
      pollingTimerCotization: null,
      isWhitelabel: this.$isWhitelabel(),
      showTopWarning: false,
      TIPOS_NOTIFICACOES: {
        default: 'text-primary',
        danger: 'text-danger',
        success: 'text-success',
        warning: 'text-warning',
        info: 'blue--text',
      },
      expandSubMenu: {
        tarefas: false,
        workspace: false,
        carteira: false,
        'carteira.minha': false,
        simulador: false,
        clientes: false,
        servicos: false,
        contas: false,
        dashboard: false,
        valuation: false,
        gerenciar_profissionais: false,
        professionals: false,
        suporte: false,
        settings: false,
      },
      drawer: false,
      leftDrawer: false,
      leftSmallDrawer: false,
      left_expand: true,
      slideHistory: null,
      keySlideGroup: 0,
      menu: false,
      searchClientTxt: -1,
      hasErrorAccounts: false,
      optionRouteHover: null,
      fixSuspend: false,
      timeoutHover: null,
      isHover: false,
      drawerHover: false,
      navHoverLock: false,
    }
  },
  computed: {
    ...mapGetters('notifications', ['notificacoes', 'qtdNotRead', 'loading']),
    FEATURES() {
      return FEATURES
    },
    loadingComunicados() {
      return this.loading
    },
    // Ferramenta do profissional (gerenciar chaves de integração) — nunca
    // pro cliente final, mesmo com a feature ligada.
    canShowChavesApi() {
      if (this.usuarioAtual.IS_CLIENTE) return false
      return this.$access[FEATURES.CHAT_IA]
    },
    subRoutesBI() {
      const formatRoutes = [...this.$store.getters['power-bi/dashboard']].map(
        (v) => {
          return {
            title: v.title,
            name: `bi.dash`,
            params: {
              title: v.title,
              urlIframe: v.url,
            },
          }
        }
      )

      return formatRoutes
    },

    // Contexto compartilhado para os builders de rota (em @constants/navigation-routes).
    // A lista de rotas saiu deste componente; aqui só montamos o ctx (handlers =
    // métodos do componente) e delegamos. Lógica de clique/handlers continua abaixo.
    routesCtx() {
      return {
        access: this.$access,
        currentUser: this.$currentUser(),
        hideCrossSell: this.$hideCrossSell,
        showWorkspace: this.$showWorkspace,
        // Lazy: só buildAnaliseRoutes lê subRoutesBI (que toca o store power-bi).
        // Thunk evita disparar essa leitura em builders que não usam BI.
        getSubRoutesBI: () => this.subRoutesBI,
        professionalsOnlyManager: additionalPermissions.professionals(),
        handlers: {
          goToFP: this.goToFP,
          goToComissoes: this.goToComissoes,
          goToTreasury: this.goToTreasury,
          goToSettings: this.goToSettings,
          openAssetsMaturity: this.openAssetsMaturity,
          sendToGerenciarEquipe: this.sendToGerenciarEquipe,
          openProfissionais: this.openProfissionais,
          sendWorkspace: this.sendWorkspace,
          openCreateRoom: this.openCreateRoom,
          openMarketWindow: this.openMarketWindow,
          openSuporte: this.openSuporte,
          openModuloGeneral: this.openModuloGeneral,
          openSettingsFinance: this.openSettingsFinance,
          openModuloJuridico: this.openModuloJuridico,
          openModuloEstrategia: this.openModuloEstrategia,
          openSettingsCrm: this.openSettingsCrm,
          openSettingsBi: this.openSettingsBi,
          openSettingsAssetAllocation: this.openSettingsAssetAllocation,
          openSettingsFinancialPlanning: this.openSettingsFinancialPlanning,
          openSettingsComissoes: this.openSettingsComissoes,
          openSettingsRh: this.openSettingsRh,
          openSettingsCompliance: this.openSettingsCompliance,
        },
      }
    },

    routesOperational() {
      return buildOperationalRoutes(this.routesCtx)
    },

    routesManagerOffice() {
      return buildManagerOfficeRoutes(this.routesCtx)
    },

    routesManagerPortfolio() {
      return buildManagerPortfolioRoutes(this.routesCtx)
    },

    routesManagerPeople() {
      return buildManagerPeopleRoutes(this.routesCtx)
    },

    routesManagerTools() {
      return buildManagerToolsRoutes(this.routesCtx)
    },

    routesSettings() {
      return buildSettingsRoutes(this.routesCtx)
    },

    routesManagerOuters() {
      return buildManagerOutersRoutes(this.routesCtx)
    },

    routesAnalise() {
      return buildAnaliseRoutes(this.routesCtx)
    },

    routesCliente() {
      return buildClienteRoutes()
    },

    routesProfissional() {
      return buildProfissionalRoutes(this.routesCtx)
    },
    isTransparentLogo() {
      return false
    },
    dateStr() {
      return moment().format('DD [de] MMMM, YYYY')
    },
    qtdNotificacoes() {
      return this.qtdNotRead
    },
    nomeUsuario() {
      return (store.getters['user/currentUser'] || {}).nome
    },
    logoEscritorio() {
      const logoWhite = store.getters['parameters/logoBranca']
      if (
        this.$access[FEATURES.NAVIGATION_ONLY_COLOR] &&
        logoWhite &&
        logoWhite.length
      ) {
        return logoWhite
      }
      return store.getters['parameters/logo']
    },
    faviconEscritorio() {
      const faviconWhite = store.getters['parameters/faviconBranca']
      if (
        this.$access[FEATURES.NAVIGATION_ONLY_COLOR] &&
        faviconWhite &&
        faviconWhite.length
      ) {
        return faviconWhite
      }
      return store.getters['parameters/favicon']
    },
    formattedPerfis() {
      return (this.usuarioAtual.perfis_disponiveis || []).map((p) => {
        return toTitleCase(p)
      })
    },

    defaultRoutes() {
      return buildRoutes(this.routesCtx)
    },
    usuarioAtual() {
      return store.getters['user/currentUser'] || {}
    },
    hasIncompletesAssets() {
      return store.getters['user/hasIncompletesAssets']
    },
    show() {
      if (this.$route) {
        return !!this.$route.meta.hide_nav
      }
      return false
    },
    showNotifications() {
      return true // this.usuarioAtual.IS_CLIENTE
    },
    clientes() {
      return store.getters['user/allClients'] || []
    },
    statusCliente() {
      return store.getters['clientStatus/status']
    },
    historicoClientes() {
      return store.getters['user/getSearchedClients'] || []
    },
    showCurrentClient() {
      return false
      // if (this.$route) {
      //   return this.$route.meta.show_current_client
      // }
      // return false
    },
    mini() {
      return this.leftDrawer
    },
    paginaAtual() {
      if (!this.$route) {
        return ''
      }
      return this.$route.name
    },

    textColorContrastNav() {
      const bg = this.$Color()['bg-navbar']

      const textColor = textOnColor(bg)

      return textColor
    },

    textColorContrastNavHeader() {
      const bg = this.$Color()['bg-navbar-header']

      const textColor = textOnColor(bg)

      return textColor
    },

    isSmall() {
      if (this.$vuetify.breakpoint) {
        return this.$vuetify.breakpoint.smAndDown
      } else {
        return false
      }
    },

    bgColorByFlag() {
      if (this.$access[FEATURES.NAVIGATION_ONLY_COLOR]) {
        return 'var(--bg-navbar)'
      }
      return '#FFFFFF'
    },

    borderBottomByFlag() {
      if (this.$access[FEATURES.NAVIGATION_ONLY_COLOR]) {
        if (this.$router.name === 'home') {
          return '2px solid var(--bg-navbar)'
        }
        return ''
      }
      return '2px solid rgb(239, 238, 235)'
    },

    colorBell() {
      if (this.$access[FEATURES.NAVIGATION_ONLY_COLOR]) {
        return this.textColorContrastNavHeader
      }
      return 'primary'
    },
    isXs() {
      if (this.$vuetify && this.$vuetify.breakpoint) {
        return this.$vuetify.breakpoint.xsOnly
      }
      return false
    },
  },
  watch: {
    leftDrawer(newValue) {
      store.dispatch('parameters/saveConfigLocal', { leftbar_expand: newValue })
    },
    paginaAtual: {
      handler: function (newValue) {
        if (!this.isXs) {
          Object.entries(this.expandSubMenu).forEach((e) => {
            if (this.subIsActive('/simulador', { name: e[0] })) {
              this.$set(this.expandSubMenu, e[0], true)
            } else {
              if (this.expandSubMenu[e[0]]) {
                this.$set(this.expandSubMenu, e[0], false)
              }
            }
          })
        }
      },
      deep: true,
    },
  },
  mounted() {
    if (!this.$currentUser().IS_CLIENTE) {
      this.leftDrawer = this.$configLocal().leftbar_expand
    }
    this._handleWindowClick = () => {
      if (this.$refs.menu_profile) {
        if (this.$refs.selectPerfil) {
          if (!this.$refs.selectPerfil.isActive) {
            this.$refs.menu_profile.isActive = false
          }
        } else {
          this.$refs.menu_profile.isActive = false
        }
      }
    }
    window.addEventListener('click', this._handleWindowClick)
    this._onRunningCotizacao = () => {
      this.runningCotizacao = true
    }
    GlobalBus.$on(RUNNING.COTIZACAO, this._onRunningCotizacao)
    this._onStopCotizacao = () => {
      this.runningCotizacao = false
    }
    GlobalBus.$on(STOP.COTIZACAO, this._onStopCotizacao)
    GlobalBus.$on(ACTION.NAVBAR_HOVER_LOCK, this.setNavHoverLock)
    apiNotifications.carregar()
    this.getAccounts()

    GlobalBus.$on(ACTION.COTIZAR_CLIENTE, this.cotizarCliente)
  },

  created() {
    apiPowerBIDashboard.carregar()
  },

  beforeDestroy() {
    this.pollingCancelled = true
    clearTimeout(this.pollingTimerAccounts)
    clearTimeout(this.pollingTimerCotization)
    clearTimeout(this.timeoutHover)
    if (this._handleWindowClick)
      window.removeEventListener('click', this._handleWindowClick)
    if (this._onRunningCotizacao)
      GlobalBus.$off(RUNNING.COTIZACAO, this._onRunningCotizacao)
    if (this._onStopCotizacao)
      GlobalBus.$off(STOP.COTIZACAO, this._onStopCotizacao)
    GlobalBus.$off(ACTION.COTIZAR_CLIENTE, this.cotizarCliente)
    GlobalBus.$off(ACTION.NAVBAR_HOVER_LOCK, this.setNavHoverLock)
    apiNotifications.stop()
  },

  methods: {
    // Regra em `@utils/clienteEmail`. Ao extrair este seletor para componente
    // próprio, pré-compute como o `client-search` (`emailExibido` na linha).
    emailDoCliente,
    openModuloJuridico() {
      if (this.$access[FEATURES.CAPTABLE]) {
        this.$router.push({ name: 'settings-v2.juridico' })

        return
      }

      this.$router.push({
        name: 'without-access',
        params: { module: 'Partnership' },
      })
    },

    openSettingsBi() {
      if (
        this.$access[FEATURES.BI_CUSTOMIZED] ||
        this.$access[FEATURES.BI_V2]
      ) {
        this.$router.push({ name: 'settings-v2.bi' })

        return
      }
      this.$router.push({
        name: 'without-access',
        params: { module: 'BI' },
      })
    },
    openModuloEstrategia() {
      if (this.$access[FEATURES.ESTRATEGIA]) {
        this.$router.push({ name: 'settings-v2.estrategia' })

        return
      }

      this.$router.push({
        name: 'without-access',
        params: { module: 'Estrategia' },
      })
    },
    openModuloGeneral() {
      this.$router.push({ name: 'settings-v2.general' })
    },

    openSettingsFinance() {
      if (this.$access[FEATURES.BPO_FINANCE]) {
        this.$router.push({
          name: financeSettingsRouteName(this.$currentUser(), this.$access),
        })

        return
      }

      this.$router.push({
        name: 'without-access',
        params: { module: 'Financeiro' },
      })
    },

    openSettingsAssetAllocation() {
      this.$router.push({ name: 'settings-v2.asset_allocation' })
    },
    openSettingsFinancialPlanning() {
      // Settings de Financial Planning agora é gateado por
      // FINANCIAL_PLANNING_SIMULATOR — a flag legacy FINANCIAL_PLANNING ficou
      // reservada para a calculadora PGBL standalone.
      if (this.$access[FEATURES.FINANCIAL_PLANNING_SIMULATOR]) {
        this.$router.push({ name: 'settings-v2.financial-planning' })
        return
      }

      this.$router.push({
        name: 'without-access',
        params: { module: 'Financial Planning' },
      })
    },

    openSettingsComissoes() {
      this.$router.push({ name: 'settings-v2.comissoes' })
    },

    openSettingsRh() {
      this.$router.push({ name: 'settings-v2.rh' })
    },

    openSettingsCompliance() {
      this.$router.push({ name: 'settings-v2.compliance' })
    },

    openSettingsCrm() {
      this.$router.push({ name: 'settings-v2.crm' })
    },

    openMarketWindow() {
      const w = window.screen.availWidth
      const h = window.screen.availHeight
      const url =
        (process.env.NODE_ENV === 'production' ? '/investimentos/' : '') +
        'mercado'
      window.open(url, '_blank', `height=${h / 1.5},width=${w - 100}`)
    },
    subIsActive(input, to) {
      const route = this.$route || {}
      const validRoute =
        route.name &&
        (route.name === to.name || route.name.startsWith(to.name + '.'))

      if (to.params) {
        const navbarRoute = to.params
        const routeParams = route.params
        const key = Object.keys(routeParams)[0]

        return validRoute && navbarRoute[key] === routeParams[key]
      }

      if (to.children && to.children.length) {
        return to.children.includes(route.name)
      }

      return validRoute
    },
    getInitials(d) {
      return getInitials(d)
    },
    openAlterarSenha() {
      GlobalBus.$emit(MODAL.CHANGE_PASSWORD, true)
    },
    formatType(t) {
      return toTitleCase(t)
    },
    openDadosFinanceiros() {
      GlobalBus.$emit(MODAL.FINANCIAL_DATA, true)
    },
    openValuation() {
      if (!this.$access[FEATURES.ESTRATEGIA]) {
        this.$showSnack({
          text: CANT_ACCESS_FUNCTION,
          button: true,
        })
        return
      }
      if (this.$currentUser().IS_GESTOR) {
        this.$router.push({ name: 'valuation' })
      } else {
        this.$router.push({ name: 'valuation.visao_geral.individual' })
      }
    },
    searchClient() {
      GlobalBus.$emit(MODAL.SELECIONAR_CLIENTE, MODAL.OPEN_CLIENT)
    },
    lerTodosComunicados() {
      if (this.qtdNotRead > 0) {
        apiNotifications.lerTodos()
      }
    },
    expandirComunicado(comunicado) {
      this.$showModal({
        text: comunicado.conteudo[0],
        title: comunicado.nome,
        buttons: comunicado.url
          ? [
              {
                text: 'Acessar',
                action: () => {
                  // window.open(comunicado.url, '_blank')
                  this.abrirUrlComunicado(comunicado)
                },
                class: { primary: true },
              },
            ]
          : null,
      })
    },
    abrirUrlComunicado(comunicado) {
      if (comunicado.tipo === 'pdf') {
        const [hash, type] = comunicado.url.split('::')
        window.open(
          window.location.origin +
            pdf.cliente[type || 'reports'] +
            `${hash}?download=true`,
          '_blank'
        )
      } else {
        window.open(comunicado.url, '_blank')
      }
    },
    expandirNotificacao(notificacao, big = true) {
      const ACOES_NOTIFICACOES = {
        carteira: this.openCarteira,
        cliente: this.openCarteira,
        servico: this.openServico,
        link: this.openLink,
        modal: this.openModal,
        pagina: this.openPagina,
      }
      if (notificacao.corpo.length >= 75 && big) {
        this.openModalBig(notificacao, ACOES_NOTIFICACOES[notificacao.acao])
      } else {
        const act = ACOES_NOTIFICACOES[notificacao.acao]
        if (act) {
          act(notificacao.link, notificacao.dado, notificacao)
        }
      }
    },
    openGlobalSearch() {
      GlobalBus.$emit(MODAL.GLOBAL_SEARCH)
    },
    openCarteira(link, dado) {
      const cliente = store.getters['user/allClients'].find((c) => {
        return c.id === dado
      })
      if (cliente) {
        store.dispatch('user/addSearchClient', cliente)
        if (this.$route.name !== 'carteira.minha') {
          this.goTo('carteira')
        }
        GlobalBus.$emit(RELOAD.ASSETS, dado)
      }
    },
    openServico(link, dado) {
      if (!this.$access[FEATURES.SERVICES]) {
        this.$showSnack({
          text: CANT_ACCESS_FUNCTION,
          button: true,
        })
        return
      }
      if (this.$route.name === 'servicos') {
        GlobalBus.$emit(MODAL.SEE_MORE_SERVICE, dado)
      } else {
        this.$router.push({ name: 'servicos', params: { servico: dado } })
      }
    },
    openLink(link, dado) {
      window.open(link || dado, '_blank')
    },
    openModalBig(notificacao, acao) {
      let buttons
      if (notificacao.acao && acao) {
        buttons = [
          {
            text: 'Cancelar',
            class: { underlined: true },
          },
          {
            text: 'Abrir',
            class: { primary: true },
            action: () => {
              this.expandirNotificacao(notificacao, false)
            },
          },
        ]
      } else {
        buttons = [
          {
            text: 'OK',
            class: { primary: true },
          },
        ]
      }
      this.$showModal({
        title: notificacao.titulo,
        text: notificacao.corpo,
        buttons: buttons,
      })
    },
    openPagina(link, dado) {
      window.location.href = dado || link
    },
    openModal(link, dado, notificacao) {
      this.$showModal({
        title: notificacao.titulo,
        text: dado,
      })
    },
    formatCorpo(corpo) {
      if (corpo.length > 100) {
        return corpo.slice(0, 100) + '...'
      } else {
        return corpo
      }
    },
    // formatContent(comunicado) {
    //   const content = comunicado.conteudo[0]
    //   if (content.length > 100) {
    //     return content.slice(0, 100) + '...'
    //   } else {
    //     return content
    //   }
    // },

    async callPerfil(a) {
      let r

      if (
        this.usuarioAtual.IS_CLIENTE &&
        ['Profissional', 'Gestor'].includes(a)
      ) {
        r = await con.get(user.client.perfil_to_professional)
      }
      if (!this.usuarioAtual.IS_CLIENTE && a === 'Cliente') {
        r = await con.get(user.profissional.perfil_to_client)
      }

      return r
    },

    async changePerfil(a) {
      const r = await this.callPerfil(a)

      // Regressão Sentry AAWZ-WEB-3YY: callPerfil pode não bater em nenhuma
      // combinação (ex.: usuário sem IS_CLIENTE/IS_ASSESSOR) e retornar undefined.
      if (!r) {
        this.$showSnack({
          text: 'Não foi possível alterar o perfil. Tente novamente ou contate o suporte.',
          button: true,
        })
        return
      }

      if (r.status === 200) {
        this.$refs.selectPerfil.isActive = false
        this.$refs.menu_profile.isActive = false

        store.dispatch('user/setCurrentUser', { loading: true })

        P.getCurrentUser(() => {
          if (
            this.$route.name !== 'carteira' &&
            this.$route.name !== 'carteira.minha'
          ) {
            // Libera os dados do contexto anterior só quando navegamos para
            // home — a view de destino remonta e refaz o fetch. Esta troca de
            // perfil é in-SPA (sem reload), então sem isso o store reteria as
            // carteiras/BI/comissões do perfil anterior. No caminho
            // carteira.minha (que preserva a rota) NÃO resetamos, senão a
            // carteira ainda montada ficaria em branco até um reload
            // [CU-86ajnmt4r]
            resetAllModules(store)
            this.goTo('home')
          }
        })
      } else {
        this.$showSnack({
          text: r.message,
          button: true,
        })
      }
    },
    goToContrato() {
      // if (this.$route.name != 'contrato') {
      //   this.goTo('contrato')
      // }
      GlobalBus.$emit(MODAL.CONTACT_WHITELABEL)
    },
    openMeusDados() {
      GlobalBus.$emit(MODAL.MEUS_DADOS, this.usuarioAtual, true)
    },
    openChavesApi() {
      this.menu = false
      this.$router
        .push({ name: 'aawz-intelligence.chaves-api' })
        .catch(() => {})
    },
    openExtensaoAawz() {
      GlobalBus.$emit(MODAL.EXTENSION_TOKEN)
    },
    openAvatarUpload() {
      this.menu = false
      GlobalBus.$emit(MODAL.AVATAR_UPLOAD)
    },
    openSuggest() {
      GlobalBus.$emit(MODAL.SUGGEST_IMPROVEMENT, true)
    },
    logout() {
      // Encerra o socket do workspace antes de invalidar a sessão — sem isso o
      // onclose religa a conexão (getToken 401 + telemetria) até a página descarregar
      if (this.$wsWorkspace) {
        this.$wsWorkspace.disconnect()
      }
      con.post(user.logout).then((r) => {
        window.location.href = user.tela_login
      })
    },
    goToWallet() {
      if (this.$route.name !== 'carteira.minha') {
        this.$router.push({
          name: 'carteira.minha',
          params: { toBottom: true },
        })
      } else {
        window.scrollTo({
          top: document.body.scrollHeight,
          left: 0,
          behavior: 'smooth',
        })
      }
    },
    sendToGerenciarEquipe() {
      this.goTo('professionals')
    },
    goToTreasury(access = this.$access, user = this.$currentUser()) {
      if (access[FEATURES.TREASURY]) {
        this.goTo('treasury.contas_a_pagar')
        return 'treasury.contas_a_pagar'
      }
      if (
        access[FEATURES.FATURAMENTO] &&
        (user.IS_GESTOR || user.IS_FINANCIAL)
      ) {
        this.goTo('treasury.contas_a_receber')
        return 'treasury.contas_a_receber'
      }
      if (access[FEATURES.TESOURARIA_FORMULARIO_REEMBOLSO]) {
        this.goTo('treasury.solicitations')
        return 'treasury.solicitations'
      }
      return ''
    },
    goToFP() {
      // Aponta para a raiz fp; resolveFinancialPlanningRedirect decide o destino
      // conforme a matriz Cross-Sell × Flags FP. Evita duplicar lógica de roteamento.
      this.goTo('fp')
    },
    goToComissoes() {
      if (this.$access[FEATURES.COMISSOES_OVERVIEW]) {
        // Removido a condicao de ser gestor também, para liberar a tela para todos os profissionais
        this.goTo('comissoes.visao-geral')
      } else {
        this.goTo('comissoes.fechamentos')
      }
    },
    goToSettings() {
      this.goTo('settings-v2')
    },

    goToAccounts() {
      this.goTo('contas')
    },
    getAccounts() {
      if (!this.usuarioAtual.IS_CLIENTE) {
        return
      }
      con.get(adicionarTransacao.bancos.contas_cliente).then((r) => {
        if (r && r.status === 200) {
          let has_updating = possivelJSON(r.value).find((v, i) => {
            return v.codigo !== -1 && v.status === 'Atualizando'
          })

          this.hasErrorAccounts = possivelJSON(r.value).find((v, i) => {
            return v.status !== 'Atualizando' && v.status !== 'ok'
          })

          if (has_updating) {
            this.pollingTimerAccounts = setTimeout(() => {
              if (!this.pollingCancelled) this.getAccounts()
            }, 8000)
          }
        }
      })
    },
    atualizarAll() {
      GlobalBus.$emit(MODAL.LEFT_ACTION, 'atualizarAll')
    },
    attBanks() {
      GlobalBus.$emit(MODAL.LEFT_ACTION, 'attBanks')
    },
    openEnviarAtt() {
      GlobalBus.$emit(MODAL.LEFT_ACTION, 'openEnviarAtt')
    },
    openCadastrarAtivos() {
      GlobalBus.$emit(MODAL.LEFT_ACTION, 'openCadastrarAtivos')
    },
    openAporteResgate() {
      GlobalBus.$emit(MODAL.LEFT_ACTION, 'openAporteResgate')
    },
    openPortabilidade() {
      GlobalBus.$emit(MODAL.SELECIONAR_CLIENTE, MODAL.PORTABILIDADE, true)
    },
    openProfissionais() {
      GlobalBus.$emit(MODAL.LEFT_ACTION, 'openProfissionais')
    },
    openSimulador() {
      if (!this.isWhitelabel) {
        this.needWhitelabel()
        return
      }
      GlobalBus.$emit(MODAL.LEFT_ACTION, 'openSimulador')
    },

    openAssetsMaturity() {
      this.$router.push({ name: 'assets-maturity' })
    },

    openCreateRoom() {
      GlobalBus.$emit(MODAL.CREATE_ROOM)
    },
    openResumo() {
      GlobalBus.$emit(MODAL.MODAL_RESUMO_CLIENTE)
    },
    openSuporte() {
      window.open('https://aawz.zendesk.com/hc/pt-br', '_blank')
    },
    // openFaq() {
    //   window.open(
    //     'https://aawz.zendesk.com/hc/pt-br/categories/360004472714-FAQ',
    //     '_blank'
    //   )
    //   // this.goTo('suporte.faq')
    // },
    cotizarCliente() {
      if (this.$currentUser().IS_CLIENTE) {
        // TODO: chamar cotização para cliente?
        return
      }
      if (this.runningCotizacao) {
        return
      }
      if (!this.$currentClient().id) {
        this.$showSnack({
          text: 'Selecione um cliente para atualizar.',
          button: true,
        })
        return
      }
      apiConsolidatorCotizacao.run({ id_cliente: this.$currentClient().id })

      // GlobalBus.$emit(RUNNING.COTIZACAO)
      // const data = {
      //   id_cliente_app: this.$currentClient().id,
      // }
      // const r = await con.post(atualizar.professional, data)
      // if (r && r.status === 200) {
      //   this.$showSnack({
      //     text: r.message,
      //     button: true,
      //   })
      //   setTimeout(() => {
      //     this.checkStatusCotization(data.id_cliente_app)
      //   }, 10000)
      // } else {
      //   this.$showSnack({
      //     text: r.message,
      //     button: true,
      //   })
      //   GlobalBus.$emit(STOP.COTIZACAO)
      //   GlobalBus.$emit(RELOAD.ASSETS)
      // }
    },
    async checkStatusCotization(id_cliente) {
      const r = await con.get(
        atualizar.professional_status + `?id_cliente_app=${id_cliente}`
      )
      if (r && r.status === 200) {
        if (r.value.atualizando) {
          this.pollingTimerCotization = setTimeout(() => {
            if (!this.pollingCancelled) this.checkStatusCotization(id_cliente)
          }, 10000)
          return
        }
        GlobalBus.$emit(RELOAD.ASSETS)
      }
      this.$showSnack({
        text:
          (r && r.message) ||
          'Não foi possível cotizar no momento, tente novamente mais tarde.',
        button: true,
      })
      GlobalBus.$emit(STOP.COTIZACAO)
    },

    routeAction({ name, route }) {
      if (route && route.action) {
        route.action()
        return
      }
      if (route && route.hasOwnProperty('can_show')) {
        const hasPermission =
          this.$access[route.can_show] || route.can_show === true
        if (!hasPermission) {
          this.$showSnack({
            text: CANT_ACCESS_FUNCTION,
            button: true,
          })
          return
        }
      }
      if (!this.subIsActive('/simulador', { name: name })) {
        if (this.$router) {
          this.$router.push({ name: name })
        }
      }
    },

    goTo(name, route) {
      if (route && route.whitelabel_only && !this.isWhitelabel) {
        this.needWhitelabel()
        return
      }
      this.routeAction({ name, route })
    },
    goToCtrl(name, route) {
      if (route && route.whitelabel_only && !this.isWhitelabel) {
        this.needWhitelabel()
        return
      }
      if (route && route.action) {
        route.action()
        return
      }
      const routeData = this.$router.resolve({ name: name })
      if (routeData && routeData.href !== '/') {
        window.open(routeData.href, '_blank')
      }
    },
    needWhitelabel() {
      funcaoIndisponivel(this)
    },
    selectClient(client) {
      store.dispatch('user/addSearchClient', client)
      GlobalBus.$emit('changeClient')
    },
    search(_id) {
      const c = this.clientes.find((c) => {
        return c.id === _id
      })
      setTimeout(() => {
        this.searchClientTxt = -1
      }, 0)
      if (c) {
        this.selectClient(c)
      }
    },
    openMyData(c) {
      GlobalBus.$emit(MODAL.MEUS_DADOS, c, false, true)
    },
    customFilter(item, queryText, itemText) {
      const name = removeAccents((item.name || '').toLowerCase())
      // `emailDoCliente` preserva a caixa (exibe `CLI_42` como está no banco);
      // quem compara é a busca, então ela baixa a caixa dos dois lados.
      const email = emailDoCliente(item).toLowerCase()
      const codigoCorretora = formatBrokerCode(item.codigo_corretora).toLowerCase()
      const searchText = removeAccents((queryText || '').toLowerCase())

      return (
        name.indexOf(searchText) > -1 ||
        email.indexOf(searchText) > -1 ||
        codigoCorretora.indexOf(searchText) > -1
      )
    },
    sendWorkspace() {
      if (
        [
          'carteira.analise',
          'carteira.minha',
          'carteira.minha.cliente',
        ].includes(this.$route.name)
      ) {
        GlobalBus.$emit(
          MODAL.WORKSPACE_SEND_COMPONENT,
          {
            page: this.$route.name,
            data: {
              id_cliente: this.$currentClient().id,
            },
          },
          this.$currentClient()
        )
      } else if (
        ['simulador.analise', 'simulador.comparativo'].includes(
          this.$route.name
        )
      ) {
        GlobalBus.$emit(MODAL.OPEN_SEND_COMPONENT, true)
      } else {
        this.$showSnack({
          text: 'Função ainda indisponível',
          button: true,
        })
      }
    },
    doAction(act) {
      if (act && act.whitelabel_only && !this.isWhitelabel) {
        this.needWhitelabel()
        return
      }

      if (act && act.name === 'openComoFazer') {
        window.open(
          'https://aawz.zendesk.com/hc/pt-br/categories/360004526514-Primeiros-passos',
          '_blank'
        )
        return
      }

      if (act.action) {
        act.action()
      } else {
        GlobalBus.$emit(MODAL.LEFT_ACTION, act.name)
      }
    },
    cleanExpandSubMenu(hover) {
      if (this.leftDrawer && !hover) {
        Object.entries(this.expandSubMenu).forEach((e) => {
          this.$set(this.expandSubMenu, e[0], false)
        })
      }
    },

    openLeftNavBar() {
      this.leftDrawer = !this.leftDrawer
    },

    subRouteGoto(v) {
      if (v.name === 'bi.dash') {
        this.$router.push({
          name: 'bi.dash',
          params: { title: v.params.title, urlIframe: v.urlIFrame },
        })
        return
      }

      if (typeof v.action === 'string') {
        this.doAction(v)
        return
      }

      this.goTo(v.name, v)
    },

    showSubMenu(v) {
      this.goTo(v.name, v)

      this.$set(this.expandSubMenu, v.name, !this.expandSubMenu[v.name])
    },

    showSubMenuSuspended(el, route) {
      if (this.timeoutHover) {
        clearTimeout(this.timeoutHover)
      }

      this.optionRouteHover = { ...route, position: el.y }
    },

    closeSubMenuSuspended() {
      if (!this.leftDrawer) {
        return
      }
      this.timeoutHover = setTimeout(() => {
        if (!this.fixSuspend) {
          this.optionRouteHover = null
        }
      }, 600)
    },

    fixHoverSuspend() {
      this.fixSuspend = true
    },

    removeFixSuspend() {
      this.fixSuspend = false
      this.optionRouteHover = null
    },

    borderOpacity() {
      const bg = this.$Color()['bg-navbar-header']
      // const colorOpacity = this.$setOpacity(primary, 0.3)

      const textColor = textOnColor(bg)

      return `0.5px solid ${textColor}`
    },

    setHover(hover) {
      this.drawerHover = hover
      this.isHover = hover || this.navHoverLock
    },
    setNavHoverLock(isLocked) {
      this.navHoverLock = isLocked
      this.isHover = this.drawerHover || this.navHoverLock
    },
  },
}
</script>

<template>
  <div>
    <v-app
      style="background-color: var(--neutral-50); position: relative"
      :style="{ top: showTopWarning ? '40px' : '0' }"
    >
      <v-btn
        v-if="!isXs"
        icon
        elevation="0"
        color=""
        style="
          position: absolute;
          top: 21px;
          height: 24px;
          width: 24px;
          z-index: 15;
          background: var(--bg-navbar-header);
        "
        :style="{
          border: borderOpacity(),
          left: leftDrawer && !isHover ? '92px' : '288px',
        }"
        @click.stop="openLeftNavBar"
      >
        <v-icon small :color="textColorContrastNavHeader">
          {{ !leftDrawer ? 'mdi-chevron-left' : 'mdi-chevron-right' }}
        </v-icon>
      </v-btn>

      <v-hover v-slot="{ hover }" open-delay="100" close-delay="100">
        <v-navigation-drawer
          v-model="leftSmallDrawer"
          :expand-on-hover="!isXs"
          app
          :permanent="!isXs"
          :style="{
            'z-index': isXs ? '10' : '6',
            width: leftDrawer && !(hover || navHoverLock) ? '104px' : '300px',
            top: showTopWarning ? '40px' : '0',
          }"
          class="elevation-0"
          style="overflow: initial"
          @transitionend="setHover(hover)"
        >
          <v-list-item
            v-if="isXs"
            class="elevation-0"
            color="primary"
            style="height: 64px; background-color: var(--bg-navbar-header)"
            :class="{ 'bg-primary': isTransparentLogo }"
          >
            <v-list-item-content>
              <v-list-item-title class="full-center">
                <img
                  :src="logoEscritorio"
                  style="max-width: 100%; max-height: 72px"
                />
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <div
            v-if="!isXs"
            :style="{
              // 'border-bottom': '2px solid #EFEEEB',
              height: '66px',
              width: '100%',
              'z-index': '10',
              position: 'fixed',
              padding: '19px 5px',
              // 'background-color': 'var(--primary-light)',
              'background-color': 'var(--bg-navbar-header)',
              'border-right': '1px solid #e0e0e0',
            }"
            class="full-center"
            :class="{ 'bg-primary': isTransparentLogo }"
          >
            <div
              class="full-center"
              :style="{
                // 'background-color': 'white',
                'margin-bottom': '0px',
              }"
            >
              <img
                v-if="!leftDrawer || navHoverLock || hover"
                :src="logoEscritorio"
                style="max-width: 100%; max-height: 54px"
              />
              <img
                v-else
                :src="faviconEscritorio"
                style="max-width: 100%; max-height: 54px; margin: 0px 10px"
              />
            </div>
          </div>

          <div
            :style="{
              // 'max-height': isXs
              //   ? 'calc(100vh - 74px)'
              //   : 'calc(100vh - 64px)',
              height: '100%',
              'margin-bottom': isXs ? '0px' : '10px',
              'overflow-y': 'scroll', // auto
              position: 'fixed',
              'margin-top': isXs ? '0px' : '65px',
              width: '100%',
              // 'padding-right': '7px',
              'padding-bottom': '100px',
              'background-color': 'var(--bg-navbar)',
            }"
            class="menu-list-actions"
          >
            <div v-for="(r, i) in defaultRoutes" :key="i" class="mb-2 mt-2">
              <div v-if="r.group" class="mt-1">
                <h1
                  v-if="
                    !r.hiddenTitle &&
                    !(leftSmallDrawer && leftDrawer && !(hover || navHoverLock))
                  "
                  style="font-size: 11px"
                  class="m-0 mt-5 mb-1 py-1 font-500 uppercase"
                  :style="{ color: $setOpacity(textColorContrastNav, 0.3) }"
                >
                  {{ r.title }}
                </h1>

                <div
                  v-for="(itemGroup, index) in r.routes"
                  :key="`${i}_${index}`"
                  :class="{
                    'd-flex justify-content-center': !!(
                      leftSmallDrawer &&
                      leftDrawer &&
                      !(hover || navHoverLock)
                    ),
                  }"
                >
                  <!-- @mouseover="(v) => showSubMenuSuspended(v, itemGroup)"
                    @mouseleave="closeSubMenuSuspended" -->
                  <div v-if="itemGroup">
                    <ButtonNavbar
                      :icon="itemGroup.icon"
                      :name="itemGroup.title"
                      :hasList="
                        !!(itemGroup.subRoutes && itemGroup.subRoutes.length)
                      "
                      :value="itemGroup"
                      :full="!leftDrawer || navHoverLock || hover"
                      :selected="subIsActive('/simulador', itemGroup)"
                      :isNew="itemGroup.new"
                      :noAccessIcon="itemGroup.noAccessIcon"
                      @clickEvent="showSubMenu(itemGroup)"
                    />
                  </div>

                  <div
                    v-if="
                      !!(itemGroup.subRoutes && itemGroup.subRoutes.length) &&
                      (!leftDrawer || navHoverLock || hover)
                    "
                    v-show="expandSubMenu[itemGroup.name]"
                  >
                    <div
                      v-for="(sr, j) in itemGroup.subRoutes"
                      :key="`${i}_${index}_${j}`"
                      style="position: relative"
                      :style="{ overflow: j === 0 ? 'hidden' : '' }"
                      class="mx-2"
                    >
                      <icon-svg
                        name="union-nav-bar"
                        size="42"
                        :color="$setOpacity(textColorContrastNav, 0.3)"
                        style="position: absolute; left: -8px"
                        :style="{ top: j === 0 ? '-19px' : '-22px' }"
                      />
                      <div v-if="sr" :class="{ 'mt-1': j === 0 }">
                        <ButtonNavbar
                          :icon="sr.icon"
                          :name="sr.title"
                          :full="!leftDrawer || navHoverLock || hover"
                          :value="sr"
                          class="ml-4 py-2"
                          :selected="subIsActive('/simulador', sr)"
                          sm
                          @clickEvent="subRouteGoto(sr)"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                v-else
                :class="{
                  'd-flex justify-content-center': !!(
                    leftSmallDrawer && leftDrawer
                  ),
                }"
              >
                <div
                  v-if="r"
                  @mouseover="(v) => showSubMenuSuspended(v, r)"
                  @mouseleave="closeSubMenuSuspended"
                >
                  <ButtonNavbar
                    :icon="r.icon"
                    :name="r.title"
                    :value="r"
                    :full="!leftDrawer || navHoverLock || hover"
                    :selected="subIsActive('/simulador', r)"
                    class="px-3 py-3"
                    @clickEvent="goTo(r.name, r)"
                  />
                </div>
              </div>

              <div class="divider-nav-bar"></div>

              <v-list-item
                v-if="false"
                link
                :class="{
                  // 'elevation-5': subIsActive('/simulador', r),
                  'active-menu-path': subIsActive('/simulador', r),
                }"
                style="margin-right: 5px"
                @click.exact="goTo(r.name, r)"
                @click.ctrl.exact="goToCtrl(r.name, r)"
              >
                <v-list-item-action :title="r.title" class="mr-2">
                  <!-- <v-icon style="height: 37.5px;">
                      {{ r.icon }}
                    </v-icon> -->
                  <div style="position: relative">
                    <icon-svg
                      :name="r.icon"
                      :style="{
                        color: subIsActive('/simulador', r)
                          ? 'var(--text-navbar-active)'
                          : 'currentColor',
                      }"
                    ></icon-svg>
                    <div
                      v-if="r.new"
                      style="position: absolute; bottom: -8px; right: -28px"
                    >
                      <v-chip x-small color="primary" style="color: white">
                        novo
                      </v-chip>
                    </div>
                    <div
                      v-if="r.beta"
                      style="position: absolute; bottom: -8px; right: -28px"
                    >
                      <v-chip x-small color="primary" style="color: white">
                        beta
                      </v-chip>
                    </div>
                  </div>
                  <!-- :color="
                        subIsActive('/simulador', r)
                          ? 'primary'
                          : 'currentColor'
                      " -->
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title class="mb-0">
                    <p class="mb-0"> {{ r.title }} </p>
                  </v-list-item-title>
                </v-list-item-content>

                <v-list-item-action
                  v-if="r.second_icon"
                  style="margin-right: 5px"
                >
                  <icon-svg
                    :name="r.second_icon"
                    :color="
                      subIsActive('/simulador', r) ? 'primary' : 'currentColor'
                    "
                  ></icon-svg>
                </v-list-item-action>

                <v-list-item-action
                  v-if="r.actions && r.actions.length"
                  style="margin-left: 2px"
                  @click.stop
                >
                  <v-btn
                    icon
                    @click="expandSubMenu[r.name] = !expandSubMenu[r.name]"
                  >
                    <!-- :color="
                          subIsActive('/simulador', r)
                            ? 'primary'
                            : 'currentColor'
                        " -->
                    <icon-svg
                      :name="
                        expandSubMenu[r.name]
                          ? 'mdi-chevron-up'
                          : 'mdi-chevron-down'
                      "
                    />
                  </v-btn>
                </v-list-item-action>
              </v-list-item>

              <v-expand-transition
                v-if="!leftDrawer"
                :key="r.name + 'expansive-list'"
              >
                <v-list
                  v-show="expandSubMenu[r.name]"
                  v-if="r.actions && r.actions.length"
                  dense
                  style="
                    background-color: rgba(255, 255, 255, 0.1);
                    margin: 0px 10px 10px;
                    border-radius: 12px;
                  "
                >
                  <v-subheader
                    class="text-heading-small-medium text-color-900 font-medium"
                  >
                    Gatilhos Rápidos
                  </v-subheader>
                  <v-list-item
                    v-for="act in r.actions"
                    :key="act.tile"
                    link
                    @click="doAction(act)"
                  >
                    <v-list-item-action style="margin-right: 10px">
                      <icon-svg :name="act.icon || ''">
                        {{ act.icon }}
                      </icon-svg>
                    </v-list-item-action>

                    <v-list-item-content>
                      <v-list-item-title>
                        {{ act.title }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-expand-transition>
            </div>
          </div>
        </v-navigation-drawer>
      </v-hover>

      <v-app-bar
        app
        style="z-index: 5; box-shadow: none; left: 0; padding-left: 120px"
        :style="{
          top: showTopWarning ? '40px' : '0',
          backgroundColor: bgColorByFlag,
          borderBottom: borderBottomByFlag,
        }"
      >
        <!-- background-color: #f8f8f8;  -->

        <v-app-bar-nav-icon
          v-if="isXs"
          @click.stop="leftSmallDrawer = !leftSmallDrawer"
        ></v-app-bar-nav-icon>

        <div
          v-if="!isXs && !$currentUser().IS_CLIENTE"
          class="ml-1 mr-5 full-center flex-row"
          style="width: 34%"
          :class="{
            'd-none': !showCurrentClient,
          }"
        >
          <div class="v-application">
            <v-menu
              v-if="historicoClientes.length"
              open-on-hover
              :close-on-click="false"
              :nudge-width="200"
              offset-y
            >
              <template v-slot:activator="{ on }">
                <v-btn text class="mr-2" v-on="on">
                  <div>
                    <small>
                      Últimos
                      <br />
                      acessados
                    </small>
                  </div>
                  <v-icon color="primary">mdi-chevron-down</v-icon>
                </v-btn>
              </template>
              <v-card width="500" class="p-10">
                <v-sheet style="background-color: transparent">
                  <v-slide-group
                    :key="keySlideGroup"
                    v-model="slideHistory"
                    :show-arrows="historicoClientes.length > 3"
                  >
                    <v-slide-item
                      v-for="cliente in historicoClientes"
                      :key="'h-' + cliente.id"
                      v-slot
                    >
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <BaseButton
                            dark
                            outline
                            small
                            class="mr-1"
                            :style="{ 'white-space': 'normal' }"
                            v-on="on"
                            @click="selectClient(cliente)"
                          >
                            {{ getInitials(cliente.name) }}
                          </BaseButton>
                        </template>
                        <span> {{ cliente.name }} </span>
                      </v-tooltip>
                    </v-slide-item>
                  </v-slide-group>
                </v-sheet>
              </v-card>
            </v-menu>
          </div>
          <div style="width: 100%">
            <v-autocomplete
              ref="campo"
              v-model="searchClientTxt"
              placeholder="Pesquisar outro cliente"
              dense
              hide-details
              filled
              full-width
              background-color="#F1EFF2"
              style="background-color: #f1eff2"
              class="mb-0 mr-2 search-field input short-search no-append-inner"
              append-outer-icon="mdi-magnify"
              append-icon=" "
              :items="clientes"
              item-value="id"
              item-text="name"
              label=""
              autocomplete="off"
              :filter="customFilter"
              @change="search"
            >
              <template v-slot:item="data">
                <v-list-item-content style="display: table-column">
                  <v-row style="padding: 5px; align-items: center">
                    <v-icon
                      v-if="!data.item.id_cadastro_cliente"
                      small
                      right
                      color="primary"
                    >
                      mdi-account
                    </v-icon>
                    <v-icon v-else small right> mdi-account-switch </v-icon>
                    <p style="margin-bottom: 0px; margin-left: 5px">{{
                      data.item.name
                    }}</p>
                  </v-row>
                  <v-row>
                    <small style="margin-left: 15px" class="text-secondary">{{
                      emailDoCliente(data.item)
                    }}</small>
                  </v-row>
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </div>
        </div>
        <v-toolbar-title
          v-if="!$currentUser().IS_CLIENTE"
          class="full-center flex-row"
          :class="{
            'd-none': !showCurrentClient,
          }"
        >
          <!-- style="margin-left: -22%;" -->
          <small
            v-if="!$currentClient().name"
            class="text-secondary"
            style="font-size: 0.75rem"
          >
            Nenhum cliente selecionado
          </small>
          <div
            v-if="$currentClient().name"
            class="full-center align-items-baseline"
          >
            <small style="font-size: 0.75rem">Você está em:</small>
            <v-hover v-slot="{ hover }">
              <div>
                <p class="text-bold mb-0" style="font-size: 0.95rem">
                  {{ $currentClient().name }}
                </p>
                <v-slide-y-transition
                  v-if="$isWhitelabel() && !$currentUser().IS_CLIENTE"
                >
                  <div
                    v-show="hover"
                    style="
                      position: absolute;
                      top: 75px;
                      left: 50%;
                      transform: translate(-50%, -50%);
                    "
                  >
                    <!-- <v-btn-toggle
                      style="display: flex; align-items:center; height: 38px;"
                    >
                      <BaseButton
                        class="ml-0"
                        small
                        v-for="s in statusCliente"
                        :primary="s.color === 'primary'"
                        :dark="s.color === 'dark'"
                        :outline="!s.checked"
                      >
                        <span style="white-space: normal;">
                          {{ s.title }}
                        </span>
                      </BaseButton>
                    </v-btn-toggle> -->
                    <LineProcess hideDescription />
                  </div>
                </v-slide-y-transition>
              </div>
            </v-hover>
          </div>
          <v-btn
            icon
            small
            style="margin-top: auto"
            class="ml-1"
            @click="openMyData($currentClient())"
          >
            <v-icon small color="primary">mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            v-if="
              $currentClient().name &&
              !isXs &&
              !$currentUser().IS_CLIENTE &&
              $isWhitelabel()
            "
            text
            class="ml-4"
            @click="openResumo"
          >
            <v-avatar color="primary" size="30" class="elevation-2">
              <v-icon color="white" small>mdi-plus</v-icon>
            </v-avatar>
            <small class="ml-2">Resumo do cliente</small>
          </v-btn>
        </v-toolbar-title>
        <v-spacer />
        <div class="full-center flex-row" @click.stop>
          <v-btn
            v-if="!$currentUser().IS_CLIENTE"
            icon
            aria-label="Buscar páginas, ações ou clientes (Ctrl+K)"
            @click.stop="openGlobalSearch"
          >
            <icon-svg name="mdi-magnify" :color="colorBell" />
          </v-btn>
          <span class="text-heading-small-medium" :style="{ color: colorBell }">
            {{ dateStr }}
          </span>
          <v-btn
            v-if="showNotifications"
            icon
            @click.stop="
              () => {
                drawer = !drawer
                lerTodosComunicados()
              }
            "
          >
            <icon-svg name="bell" :color="colorBell" />
            <div
              v-if="qtdNotRead"
              class="elevation-2"
              style="
                position: absolute;
                top: -10px;
                right: 6px;
                background: var(--primary);
                color: white;
                border-radius: 20px;
                padding: 0px 4px 3px;
              "
            >
              <small> {{ qtdNotRead }} </small>
            </div>
          </v-btn>
          <v-fab-transition>
            <!--            v-if="runningCotizacao" -->
            <v-tooltip>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-if="$store.getters['consolidator/cotizacaoLoading']"
                  icon
                  class="text-primary"
                  v-on="on"
                >
                  <v-progress-circular
                    title="A rentabilidade da sua carteira está sendo calculada."
                    indeterminate
                    color="primary"
                    size="25"
                  >
                  </v-progress-circular>
                </v-btn>
              </template>
              <span> A rentabilidade da carteira está sendo calculada </span>
            </v-tooltip>
          </v-fab-transition>
          <v-fab-transition>
            <v-tooltip
              v-if="hasErrorAccounts && usuarioAtual.IS_CLIENTE"
              bottom
            >
              <template v-slot:activator="{ on }">
                <v-btn icon class="text-danger" v-on="on" @click="goToAccounts">
                  <v-icon>mdi-reload-alert</v-icon>
                </v-btn>
              </template>
              <span>
                Não foi possível atualizar todos os seus dados. <br />
                Clique aqui para visualizar.
              </span>
            </v-tooltip>
          </v-fab-transition>

          <v-menu
            ref="menu_profile"
            v-model="menu"
            :nudge-width="200"
            :close-on-content-click="true"
            offset-x
            left
          >
            <template v-slot:activator="{ on }">
              <div>
                <v-btn v-if="!isXs" text v-on="on">
                  <ProfessionalAvatar
                    :professional="$currentUser()"
                    :avatarUrl="$currentUser().avatar_url"
                    textSize="16px"
                  />
                  <span
                    class="text-heading-small ml-3/4rem"
                    :style="{ color: colorBell }"
                  >
                    {{ $currentUser().nome }}
                  </span>
                  <v-icon class="ml-1" color="primary">
                    mdi-chevron-down
                  </v-icon>
                </v-btn>
                <v-btn v-if="isXs" icon small v-on="on">
                  <v-icon small>mdi-dots-vertical</v-icon>
                </v-btn>
              </div>
            </template>

            <v-card>
              <v-list>
                <v-list-item>
                  <v-list-item-avatar
                    class="avatar-clickable"
                    @click.stop="openAvatarUpload"
                  >
                    <ProfessionalAvatar
                      :professional="$currentUser()"
                      :avatarUrl="$currentUser().avatar_url"
                      textSize="16px"
                    />
                    <v-icon class="avatar-camera-icon" x-small color="white">
                      mdi-camera
                    </v-icon>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title class="text-heading-small">
                      {{ nomeUsuario || 'Usuário' }}
                    </v-list-item-title>
                    <v-list-item-subtitle
                      v-if="usuarioAtual.IS_ASSESSOR"
                      class="text-heading-small-medium"
                    >
                      {{ usuarioAtual.escritorio.nome || '' }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>

              <v-divider
                :style="{
                  display: 'block',
                  border: 'solid',
                  'border-width': 'thin 0 0 0',
                  'margin-top': '0px',
                  'margin-bottom': '0px',
                  'border-color': 'rgba(0,0,0,.12)',
                  background:
                    'radial-gradient(50% 50% at 50% 50%, #B7E1A7 0%, rgba(94, 114, 102, 0) 100%);',
                }"
              ></v-divider>

              <v-list>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>
                      <a
                        href="javascript:void(0)"
                        :style="{
                          'font-size': '0.75rem !important',
                        }"
                        class="text-dark"
                        @click="openMeusDados"
                      >
                        Meus dados
                      </a>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item v-if="canShowChavesApi">
                  <v-list-item-content>
                    <v-list-item-subtitle>
                      <a
                        href="javascript:void(0)"
                        :style="{
                          'font-size': '0.75rem !important',
                        }"
                        class="text-dark"
                        @click="openChavesApi"
                      >
                        Chaves de API
                      </a>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  v-if="
                    $access[FEATURES.TRANSCRICOES] && !usuarioAtual.IS_CLIENTE
                  "
                >
                  <v-list-item-content>
                    <v-list-item-subtitle>
                      <a
                        href="javascript:void(0)"
                        :style="{
                          'font-size': '0.75rem !important',
                        }"
                        class="text-dark"
                        @click="openExtensaoAawz"
                      >
                        Extensão AAWZ
                      </a>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle style="padding-bottom: 5px">
                      <a
                        href="javascript:void(0)"
                        :style="{
                          'font-size': '0.75rem !important',
                        }"
                        class="text-dark"
                        @click="openSuggest"
                      >
                        Enviar sugestão/dúvida/problema
                      </a>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>
                      <a
                        href="javascript:void(0)"
                        :style="{
                          'font-size': '0.75rem !important',
                        }"
                        class="text-dark"
                        @click="openAlterarSenha"
                      >
                        Alterar senha
                      </a>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  v-if="
                    usuarioAtual.IS_CLIENTE
                      ? usuarioAtual.perfis_disponiveis.includes('profissional')
                      : (usuarioAtual.perfis_disponiveis || []).length > 1
                  "
                >
                  <v-list-item-content>
                    <v-list-item-subtitle @click.stop>
                      <v-select
                        ref="selectPerfil"
                        :value="formatType(usuarioAtual.tipo_usuario)"
                        :items="formattedPerfis"
                        item-value=""
                        class="text-secondary"
                        :item-text="formatType"
                        color="secondary"
                        label="Tipo de perfil"
                        dense
                        flat
                        hide-details
                        @change="changePerfil"
                      >
                      </v-select>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>

              <v-card-actions
                :style="{
                  padding: '16px',
                }"
              >
                <!-- <v-btn text @click="menu = false">Sair</v-btn> -->
                <a
                  href="javascript:void(0)"
                  :style="{
                    'font-size': '0.75rem !important',
                  }"
                  class="text-primary text-bold text-italic"
                  @click="logout"
                >
                  Sair
                </a>
                <v-spacer></v-spacer>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="62.129"
                  height="16.857"
                  viewBox="0 0 62.129 16.857"
                  :style="{
                    'align-self': 'flex-end',
                    'margin-top': '20px',
                    opacity: 0.3,
                  }"
                >
                  <g id="logo_top" transform="translate(-23.9 -20)">
                    <path
                      d="M30.967 20h1.188l6.951 16.857h-1.158l-2.23-5.416h-8.429l-2.23 5.416H23.9zm4.4 10.543L31.6 21.014h-.058l-3.91 9.529z"
                      class="fill"
                    ></path>
                    <path
                      d="M81.438 20h1.188l6.951 16.857h-1.158l-2.23-5.416h-8.4l-2.23 5.416H74.4zm4.432 10.543l-3.77-9.529h-.058l-3.91 9.529z"
                      transform="translate(-35.873)"
                      class="fill"
                    ></path>
                    <path
                      d="M193.324 20h12.339v.9L193.73 35.959h12.136v.9H192.6v-.9L204.475 20.9h-11.151z"
                      transform="translate(-119.837)"
                      class="fill"
                    ></path>
                    <path
                      d="M111.829 20.592a.217.217 0 0 1-.029-.145c0-.232.116-.348.377-.348h1.68c.174 0 .261.087.319.261l4.692 13.208 3.476-6.112a1.417 1.417 0 0 1 .348-.377.862.862 0 0 1 .434-.145h.985a1.083 1.083 0 0 1 .434.145.685.685 0 0 1 .319.377l4.75 8.66c.029.029.029.058.029.116 0 .087-.058.116-.145.116h-1.188a.862.862 0 0 1-.434-.145.88.88 0 0 1-.348-.377l-3.939-6.951-3.939 6.951a.825.825 0 0 1-.782.492h-1.13c-.174 0-.261-.087-.319-.261z"
                      transform="translate(-62.44 -.071)"
                      class="fill"
                    ></path>
                    <path
                      d="M172.406 33.54a.254.254 0 0 1-.261.2.3.3 0 0 1-.232-.116l-.956-1.709a.681.681 0 0 1-.058-.232c0-.087 0-.116.029-.145l3.563-11.035a.654.654 0 0 1 .145-.319.354.354 0 0 1 .261-.087h1.477a.489.489 0 0 1 .145.058c.058.029.087.087.087.2a.217.217 0 0 1-.029.145z"
                      transform="translate(-104.422 -.071)"
                      class="fill"
                    ></path>
                  </g>
                </svg>
              </v-card-actions>
            </v-card>
          </v-menu>
        </div>
      </v-app-bar>

      <v-navigation-drawer
        v-if="showNotifications"
        v-model="drawer"
        fixed
        app
        temporary
        right
        dark
        width="300px"
        color="#2d212f"
      >
        <v-list color="#2d212f" class="elevation-10">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="d-flex align-items-center">
                Minhas notificações
                <strong v-if="qtdNotRead"> ({{ qtdNotRead }}) </strong>
                <v-spacer />
                <v-btn
                  v-if="notificacoes.length"
                  small
                  color="secondary"
                  @click="goTo('notifications')"
                >
                  Ver todas
                </v-btn>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <v-divider></v-divider>

        <v-list
          v-if="usuarioAtual.IS_CLIENTE"
          nav
          three-line
          color="#2d212f"
          dense
          style="max-height: calc(100vh - 80px); overflow: auto"
        >
          <v-list-item
            v-for="item in notificacoes"
            :key="'comunicado-' + item.id"
            link
            @click="expandirComunicado(item)"
          >
            <v-list-item-content>
              <v-list-item-title style="color: var(--primary)">
                {{ item.nome }}
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ item.conteudo[0] }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-list
          v-if="!usuarioAtual.IS_CLIENTE"
          nav
          three-line
          color="#2d212f"
          dense
          style="max-height: calc(100vh - 80px); overflow: auto"
        >
          <v-list-item
            v-for="item in notificacoes"
            :key="'noty-' + item.id"
            link
            class="elevation-2"
            @click="expandirNotificacao(item)"
          >
            <v-list-item-content>
              <v-list-item-title
                :class="
                  TIPOS_NOTIFICACOES[item.tipo] || TIPOS_NOTIFICACOES['default']
                "
              >
                {{ item.titulo }}
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ formatCorpo(item.corpo) }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>

      <v-content
        :style="{
          'padding-left': isSmall ? '0' : leftDrawer ? '104px' : '300px',
        }"
      >
        <v-container
          class="p-0 m-0"
          style="
            max-width: 100%;
            overflow: auto;
            max-height: calc(100vh - 64px);
          "
        >
          <div>
            <div style="min-height: 70vh; padding-bottom: 100px">
              <slot />
            </div>
          </div>
        </v-container>
      </v-content>

      <v-system-bar
        v-if="!usuarioAtual.IS_CLIENTE && !isWhitelabel"
        app
        style="background-color: var(--green); cursor: pointer"
        @click="goToContrato"
      >
        <v-spacer />
        <p v-if="!isXs" class="mb-0 text-dark">
          Contrate <strong>plataforma White Label</strong> e entregue sua marca
          e suas cores para seu cliente.
        </p>
        <p v-else class="mb-0 text-dark" style="font-size: 0.65rem">
          Entregue sua marca e suas cores para seu cliente.
        </p>
        <v-spacer />
        <a
          href="javascript:void(0)"
          :style="{
            'font-size': isXs ? '0.65rem !important' : '0.85rem !important',
            'text-decoration': 'underline',
            'font-weight': 'bold',
          }"
          class="text-dark"
        >
          Contratar
        </a>
        <v-spacer />
      </v-system-bar>
    </v-app>

    <LeftBar
      v-if="
        $route &&
        $route.name &&
        !$route.name.includes('carteira.') &&
        !$route.name.startsWith('clientes')
      "
    />
  </div>
</template>

<style scope lang="sass">
@media print
  .dont-show-print
    display: none !important

.menu-list-actions
  padding: 10px 15px
  font-family: 'Inter'
  transition: overflow-y 0.5s ease
  .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled),
  .v-list-item__title
    color: #8e8e8e !important
    font-size: rem(14px) !important
    font-weight: 600 !important

  .v-icon.theme--light,
  .icon-svg
    color: #8e8e8e

.search-field .v-input__append-inner,
.search-field .v-input__append-outer
  margin-top: 12px !important

.active-menu-path
  color: var(--text-navbar-active) !important
  border-right: 5px solid var(--text-navbar-active)
  margin-right: 0px !important
  transition: all 0.5s ease

.active-menu-path i,
.active-menu-path p,
.active-menu-path h1
  color: var(--text-navbar-active) !important
  transition: all 0.5s ease

.avatar-clickable
  cursor: pointer
  position: relative
  &:hover .avatar-camera-icon
    opacity: 1

.avatar-camera-icon
  position: absolute
  bottom: 0
  right: 0
  background-color: rgba(0, 0, 0, 0.6)
  border-radius: 50%
  padding: 2px
  opacity: 0
  transition: opacity 0.2s ease
</style>

<style lang="sass" scope>
@import "@design/components/_main-header.sass"
@import "@design/components/_notifications.sass"

@import '@design/components/_costumer-search.sass'

aside
  position: fixed !important

.no-append-inner
  .v-input__append-inner
    display: none !important

.menu-list-actions:hover
  overflow-y: overlay !important
  padding-right: 0px !important

.divider-nav-bar
  height: 1px
  width: 100%
  background: radial-gradient(50% 50% at 50% 50%, var(--primary) 0%,rgba(94, 114, 102, 0) 100%)
  margin: 5px 0px 10px
  opacity: 0.3
</style>
